import Axios from '@/axios'

export const uploadBase64Img = data => {
  return Axios({
    url: '/face/web/file_upload/base64',
    method: 'POST',
    type: 'json',
    data
  })
}
export const uploadFiles = data => {
  return Axios({
    url: '/face/web/file_upload/multipart_file',
    method: 'POST',
    type: 'json',
    data
  })
}
